import React, { useMemo } from 'react';

import { UniversalInviteDialog } from '@vyce/core/src/views/invites';
import { InvitePreselectedTarget } from '@vyce/core/src/views/invites/types';
import { UniversalInviteProvider } from '@vyce/core/src/contexts';

import { useUniversalInviteModuleData } from './hooks';

interface Props {
  onClose: () => void;
  isOpen: boolean;
  onSuccess?: () => void;
  /** Page the dialog is opened from — its module opens on the "Where" step with it ticked */
  preselectedTarget?: InvitePreselectedTarget;
}
export const UniversalInviteModule = ({ onClose, isOpen, onSuccess, preselectedTarget }: Props) => {
  const { contextOptions, selectedCompanyId } = useUniversalInviteModuleData();

  const contextValue = useMemo(
    () => ({
      ...contextOptions,
      open: isOpen,
      onClose,
      onSuccess,
      preselectedTarget,
    }),
    [contextOptions, isOpen, onClose, onSuccess, preselectedTarget]
  );

  return (
    <UniversalInviteProvider value={contextValue}>
      {selectedCompanyId && <UniversalInviteDialog />}
    </UniversalInviteProvider>
  );
};
